// added by heliang 20211015 添加供应链
// 供应链路由
const name = '供应链'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/supplychain',
  component: Layout,
  children: [
    {
      path: 'goodsList',
      name: `商品列表`,
      component: () => import('@/view/supplychain/list'),
      children: [
        {
          path: 'editor/:itemId?',
          component: () => import('@/view/mall/pointsmallgoods/physical/add')
        }
      ]
    }
    
  ]
}
